export const DELETE_PHOTO = 'DELETE_PHOTO';
export const LOAD_PHOTOS = 'LOAD_PHOTOS';
export const GET_ERRORS = 'GET_ERRORS';
export const AUTH = 'AUTH';
export const ALERT = 'ALERT';